/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class RedeemedSubscriptionCounts {
    'contract': string;
    'token_id': number;
    'count': number;
    'name': string;
    'image_url': string;
    'mint_date': string;
    'szn': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "token_id",
            "baseName": "token_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "image_url",
            "baseName": "image_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "mint_date",
            "baseName": "mint_date",
            "type": "string",
            "format": ""
        },
        {
            "name": "szn",
            "baseName": "szn",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return RedeemedSubscriptionCounts.attributeTypeMap;
    }

    public constructor() {
    }
}
